import { Box, Meter } from 'grommet';
import React from 'react';

const MilestoneProgressBar = ({milestones, paidAmount, invoiceTotal}) => {
    if (!milestones || !milestones.length) return (<></>);
    let balance = paidAmount;
    return (
        <Box direction="row" gap="xsmall">
            {milestones.map((milestone, index) => {
                let progressPercentage;
                // this milestone is paid in full
                if (balance <= 0) {
                    progressPercentage = 0;
                } else if (balance >= milestone?.amount) {
                    progressPercentage = 100;
                    balance -= milestone.amount;
                } else if (balance <= milestone?.amount) {
                    progressPercentage = balance / milestone?.amount;
                    balance = 0;
                }
                return (
                    <Box key={index} width={`${milestone?.amount / invoiceTotal * 100}%`}>
                        <Meter
                            thickness="xxsmall" 
                            size="full" 
                            values={[{ value: progressPercentage, color: "status-ok", size: "full" }]} 
                            background="border"/>
                    </Box>
                )
            })}
        </Box>
    )
}

export default MilestoneProgressBar;